import React, {Component} from 'react';

export default class DefaulBody extends Component {


	handleUpload = (e) => {
		this.props.upload(e);
	}

	handleCamera = () => {
		if(this.navigatorCheck()) {
			this.props.camera();
			return;
		}
		alert('Streaming is not supported in your browser');
	}

	navigatorCheck = (e) => {
        return navigator.getUserMedia = ( navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
			navigator.msGetUserMedia);
    };

	render() {
		return (
			<div className="row" style={this.props.visibility ? {display: 'block'} : {display: 'none'}}>
        		<div className="col-md-6">
        			<form id={this.props.id}>
                        <span className="btn green btn-file btn-block">
                        <span className="fileinput-new"> Select file </span>
                        	<input type="file" name="uploadfile" id="imageUploadFile" accept="image/*" onChange={this.handleUpload} />
                        </span>														
                    </form>
        		</div>
        		<div className="col-md-6">
        			<button type="button" className="btn green btn-block" onClick={this.handleCamera}>Camera</button>
        		</div>
        	</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/UserProfileModal/DefaultBody.js
 **/